import * as React from 'react';

export type TimelineContextProps = {
  orientation: 'horizontal' | 'vertical';
};

export const TimelineContext = React.createContext<TimelineContextProps | null>(null);

export function useTimeline() {
  const context = React.useContext(TimelineContext);

  if (!context) {
    throw new Error('useTimeline must be used within a <Timeline />.');
  }

  return context;
}
